<div
    class="sidebar"
    [class.sidebar-close]="!openSidebar">
    <div
        class="mobile-tab"
        [ngClass]="{ active: mobileTab }">
        <a
            class="tab-container"
            routerLink="/mobile"
            (click)="setTopTab('mobile')">
            <img
                src="assets/images/svg/app.svg"
                width="19"
                height="19"
                alt=""
             />
            <span>iOS & Android</span>
        </a>
    </div>
    <!-- <div
        class="mobile-tab e-sports"
        [ngClass]="{ active: sportTab }">
        <a
            class="tab-container"
            routerLink="/e-sports"
            (click)="setTopTab('e-sports')">
            <img
                src="assets/images/svg/e-sports.svg"
                width="19"
                height="19"
                alt=""
             />
            <span>E-sports</span>
        </a>
    </div> -->
    <div class="sport-fav">
        <div class="favourite-container">
            <div
                class="f-comp-menu"
                (click)="toggleDropdown('favourite')">
                <img
                    src="assets/images/svg/star.svg"
                    class="fav-star-icon"
                 />
                <label class="favourite-label">
                    {{ 'sidebar.favourite_competitions' | transloco }}
                </label>
                <img
                    src="../../../assets/images/svg/arrow-down.svg"
                    class="sports-svg"
                    id="svg-icon"
                    [ngClass]="{ rotate: isDropdownOpen['favourite'] }"
                 />
            </div>
            @if (isDropdownOpen['favourite']) {
                <div class="category-c-container">
                    <div class="category-c-name">
                        <label class="favourite-label-m">
                            {{ 'sidebar.favourite_competitions' | transloco }}
                        </label>
                        @for (comp of favouriteCompetitions(); track trackByFactory('id')) {
                            <div class="category-container">
                                <div class="c-name">
                                    <div>
                                        <img
                                            src="../../../assets/images/svg/soccer-outer.svg"
                                            class="link-img-up" />
                                    </div>
                                    <a
                                        [routerLink]="[
                                            '/sport',
                                            SportEnum[comp.sportId],
                                            'tournament',
                                            comp.id,
                                        ]"
                                        class="fav-competition-name">
                                        <h3 class="comp-name">{{ comp.name }}</h3>
                                    </a>
                                    <div class="fav-checkbox">
                                        <input
                                            type="checkbox"
                                            name=""
                                            [(ngModel)]="comp.isChecked" />
                                    </div>
                                </div>
                            </div>
                        }
                        @if (isAnyCheckboxChecked()) {
                            <div>
                                <button
                                    class="btn btn-primary fav-btn"
                                    (click)="routeToTournaments(favouriteCompetitions())">
                                    <span>{{ 'sidebar.show_selected' | transloco }}</span>
                                </button>
                            </div>
                        }
                    </div>
                    <hr class="fav-hr" />
                </div>
            }
        </div>

        <div class="sport-tab-m">
            <div
                class="sports-tab"
                (click)="toggleDropdown('sports')">
                <label class="sport-label col-10">{{ 'sidebar.sports.title' | transloco }}</label>
                <img
                    src="../../../assets/images/svg/arrow-down.svg"
                    class="sports-svg"
                    [ngClass]="{ rotate: isDropdownOpen['sports'] }"
                 />
            </div>
            @if (isDropdownOpen['sports']) {
                <div>
                    <ul
                        class="nav-links"
                        id="nav-links">
                        @for (sport of sports; track trackByFactory('sportId')) {
                            <li>
                                <div
                                    class="dropdown-arrow"
                                    [class.active]=""
                                    [ngStyle]="{
                                        'background-color':
                                            activeSport === sport.sportName
                                                ? 'var(--main-bg)'
                                                : 'transparent',
                                    }">
                                    <div
                                        class="dropdown-title"
                                        (click)="activeSportName(sport.sportName, sport.sportId)">
                                        @if (activeSport === sport.sportName) {
                                            <img
                                                src="../../../assets/images/svg/{{
                                                    removeSportColons(sport.sportId.toLowerCase())
                                                }}.svg"
                                                class="link-img"
                                                alt="Icon" />
                                        } @else {
                                            <img
                                                src="../../../assets/images/svg/{{
                                                    removeSportColons(sport.sportId.toLowerCase())
                                                }}-outer.svg"
                                            
                                                [class.football-icon]="sport.sportId === 'sr:sport:1'"
                                                class="link-img"
                                                alt="Icon" />
                                        }
                                        <a
                                            class="link_name"
                                            (click)="setActiveSport(sport.sportName)"
                                            [ngClass]="{
                                                'active-link': activeSport === sport.sportName,
                                            }">
                                            {{ getSportNameLocalized(sport.sportName) | transloco }}
                                        </a>
                                    </div>
                                    <div
                                        class="sports-svg-container"
                                        (click)="toggleDropdown(sport.sportName)">
                                        <img
                                            src="../../../assets/images/svg/arrow-down.svg"
                                            class="sports-svg"
                                            id="svg-icon"
                                            [ngClass]="{
                                                rotate: isDropdownOpen[sport.sportName],
                                            }"
                                        
                                             />
                                    </div>
                                </div>
                                @if (isDropdownOpen[sport.sportName]) {
                                    <div>
                                        <div class="sub-menu">
                                            @for (
                                                mainComp of sport.mainCompetitions;
                                                track trackByFactory('id')
                                            ) {
                                                <div>
                                                    <li
                                                        class="sub-menu-item"
                                                        (click)="
                                                            routeToTournament(
                                                                sport.sportId,
                                                                mainComp.id
                                                            )
                                                        ">
                                                        <a class="competition-event">
                                                            {{ mainComp.name }}
                                                        </a>
                                                    </li>
                                                </div>
                                            }
                                            @for (
                                                template of getSportTemplate(sport.sportName);
                                                track trackByFactory('title')
                                            ) {
                                                <div>
                                                    <li
                                                        class="sub-menu-item"
                                                        (click)="toggleTemplate(template.title)">
                                                        <a class="template-title">
                                                            {{ template.title }}
                                                        </a>
                                                        <img
                                                            src="../../../assets/images/svg/arrow-down.svg"
                                                            class="sports-svg"
                                                            id="svg-icon"
                                                            [ngClass]="{
                                                                rotate: isDropdownOpen[
                                                                    template.title
                                                                ],
                                                            }"
                                                         />
                                                    </li>
                                                    @if (isSubDropdownOpen[template.title]) {
                                                        <div class="template-events">
                                                            @if (template) {
                                                                @for (
                                                                    templateEvent of template.events;
                                                                    track trackByFactory('eventId')
                                                                ) {
                                                                    <div>
                                                                        <a
                                                                            (click)="
                                                                                routeToTournament(
                                                                                    sport.sportId,
                                                                                    templateEvent.id
                                                                                )
                                                                            "
                                                                            class="template-event col-12">
                                                                            {{ templateEvent.name }}
                                                                        </a>
                                                                    </div>
                                                                }
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </li>
                        }
                    </ul>
                </div>
            }
        </div>

        <hr class="fav-hr" />
    </div>
</div>
